<template>
    <div class="text-top">
    <v-dialog
      v-model="show"
      width="540"
    >
      <v-card tile>
        <v-card-title>{{title}}</v-card-title>
        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="primary"
                text
                @click="cancelDialog"
            >
                Cancel
            </v-btn>

            <v-btn
                color="primary"
                text
                @click="confirmDelete"
            >
                Confirm
            </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    </div>
</template>
<script>
export default {
  props: {
    visible: {
      default: false,
      type: Boolean
    },
    data: {
      default: null,
      type: Object
    },
    title: {
      type: String,
      default: 'Are your sure ? '
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    cancelDialog () {
      this.$emit('close')
    },
    confirmDelete () {
      this.$emit('confirmAction', this.data)
      this.$emit('close')
    }
  }
}
</script>
